<template>
  <div class="o-card">
    <Table
      :title="$t('admins.title')"
      :description="$t('admins.description')"
      no-card
      i18n
      :loading="getAdminsLoading"
      :status="getAdminStatus"
      :items="getAdmins(page)"
      :headers="headers"
      :page="page"
      :count="getAdminCount"
      :pages="getAdminPages"
      :searchValue="search"
      @change:search="setSearchAdmins"
      @change:page="setChangedPage"
      :searchPlaceholder="$t('admins.searchPlaceholder')"
    >
      <template #new-button>
        <Button variant="light-primary" @click="showAddAdmin = true">
          + {{ $t("admins.add") }}
        </Button>
      </template>
      <template #name="{ item }">
        <div @click="showEditAdmin(item)">
          <i class="u-color-primary icofont-user"></i>
          {{ item.fullname }}
          <i
            class="icofont-warning u-color-warning"
            v-tooltip="$t('admins.departmentRoleNotSet')"
            v-if="!item.departmentUserId"
          ></i>
          <div>
            <small> {{ item.email }} </small>
            <chip
              size="sm"
              class="u-float-right"
              :variant="item.isActive ? 'primary' : 'danger'"
            >
              {{ $t(`admins.${item.role}`) }}</chip
            >
          </div>
        </div>
      </template>
      <template #phone="{ item }">
        <div @click="showEditAdmin(item)">
          {{ item.phoneNo }}
        </div>
      </template>
      <template #department="{ item }">
        <div @click="showEditAdmin(item)">
          {{ item.departmentInfo?.title }}
        </div>
      </template>
      <template #createdDate="{ item }">
        <div @click="showEditAdmin(item)">
          {{ date(item.createdDate) }}
        </div>
      </template>
      <template #isActive="{ item }">
        <div
          class="u-display-flex u-justify-content-flex-end"
          v-if="getActiveUser.userInfo.id !== item.id"
        >
          <div class="btn-group-container u-justify-content-flex-end">
            <Button
              group-item
              v-tooltip="$t('admins.activeTooltipMessage')"
              :variant="`${item.isActive ? '' : 'light-'}${
                item.isActive ? 'secondary' : 'danger'
              }`"
              @click="UPDATE_TO(true, item)"
            >
              {{ $t("common.active") }}
            </Button>
            <Button
              group-item
              v-tooltip="$t('admins.passiveTooltipMessage')"
              @click="UPDATE_TO(false, item)"
              :variant="`${!item.isActive ? '' : 'light-'}${
                item.isActive ? 'secondary' : 'danger'
              }`"
            >
              {{ $t("common.passive") }}
            </Button>
          </div>
          <Button
            class="u-margin-left"
            group-item
            v-tooltip="$t('admins.removeTooltipMessage')"
            @click="REMOVE_TO(item)"
            :variant="`light-danger`"
          >
            <i class="icofont-trash"></i>
          </Button>
        </div>
      </template>
    </Table>
    <Modal persistent v-model="showAddAdmin" hide-footer>
      <FormAdmins @refresh="getAdminsItems()" />
    </Modal>
    <Modal
      persistent
      :title="$t('admins.update')"
      hide-footer
      v-model="showUpdateAdmin"
    >
      <FormAdmins
        v-if="updateItem"
        @refresh="getAdminsItems()"
        edit
        :item="updateItem"
      />
    </Modal>
    <Modal
      :title="$t('removeAdmins.title')"
      @ok="REMOVE_ITEM"
      sm
      hide-header
      :okText="$t('common.confirm')"
      v-model="removeModal.status"
    >
      <div class="u-text-align-center">
        <img src="@/assets/images/Confirm.svg" width="250" alt="confirm" />
      </div>
      <div class="u-margin-top-small">
        <span>
          {{ $t("removeAdmins.description") }}
        </span>
      </div>
    </Modal>
  </div>
</template>

<script>
import Table from "@/components/Base/Table/index.vue";
import DateHelper from "@/helpers/date";
import { mapGetters } from "vuex";
import Chip from "../Base/Chip.vue";
import Button from "../Base/Button.vue";
import Modal from "../Base/Modal.vue";
import FormAdmins from "./FormAdmins.vue";
export default {
  components: {
    Table,
    Chip,
    Modal,
    Button,
    FormAdmins,
  },
  data() {
    return {
      page: 1,
      search: "",
      companyId: "",
      headers: [
        {
          col: 12,
          sm: 3,
          md: 3,
          lg: 3,
          title: "admins.name",
          value: "name",
          sortable: true,
        },
        {
          col: 6,
          sm: 2,
          md: 2,
          lg: 2,
          title: "admins.phone",
          value: "phone",
        },
        {
          col: 6,
          sm: 3,
          md: 3,
          lg: 3,
          title: "admins.department",
          value: "department",
        },
        {
          col: 6,
          sm: 2,
          md: 2,
          lg: 2,
          title: "common.createdDate",
          value: "createdDate",
        },
        {
          col: 12,
          sm: 2,
          md: 2,
          lg: 2,
          align: "right",
          title: "common.isActive",
          value: "isActive",
        },
      ],
      showAddAdmin: false,
      showUpdateAdmin: false,
      updateItem: null,
      removeModal: { status: false, item: {} },
    };
  },
  computed: {
    ...mapGetters([
      "getAdmins",
      "getAdminsLoading",
      "getAllAdmins",
      "getAdminPages",
      "getAdminCount",
      "getActiveUser",
      "getAdminStatus",
    ]),
  },
  methods: {
    date(value) {
      const date = new DateHelper(this.$i18n.locale);
      return date.format(value);
    },
    async UPDATE_TO(value, item) {
      await this.$store.dispatch("updateAdmin", {
        id: item.id,
        isActive: value,
      });
      this.getAdminsItems();
    },
    REMOVE_TO(item) {
      this.removeModal = {
        status: true,
        item: item,
      };
    },
    async REMOVE_ITEM(loading) {
      loading(true);
      const response = await this.$store.dispatch("removeAdmin", {
        id: this.removeModal.item.id,
      });
      if (response.message === "OK") {
        this.getAdminsItems();
        this.removeModal = {
          status: false,
          item: {},
        };
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t("removeAdmins.success"),
          variant: "success",
          duration: 2500,
        });
      } else {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t("removeAdmins.error"),
          variant: "danger",
          duration: 2500,
        });
      }
      loading(false);
    },
    showEditAdmin(item) {
      this.updateItem = item;
      this.showUpdateAdmin = true;
    },
    setQuery() {
      const page = Number(this.$route.query.page);
      const search = this.$route.query.search;
      if (!isNaN(page)) this.page = page;
      if (search) this.search = search;
      this.$store.dispatch("getAdmins", {
        query: {
          page: this.page,
          limit: 10,
          search: this.search,
        },
        force: true,
      });
    },
    getAdminsItems() {
      this.showAddAdmin = false;
      this.showUpdateAdmin = false;
      this.$store.dispatch("getAdmins", {
        query: {
          limit: 10,
          page: this.page,
          search: this.search,
        },
        force: true,
      });
    },
    setSearchAdmins(search) {
      this.search = search;
      this.page = 1;
      this.$router.replace({
        query: { ...this.$route.query, search: this.search },
      });
      this.getAdminsItems();
    },
    setChangedPage(page) {
      this.$router.replace({
        query: { ...this.$route.query, page: page, search: this.search },
      });
      this.page = page;
      this.getAdminsItems();
    },
  },
  mounted() {
    this.setQuery();
  },
};
</script>

<style></style>
